export default __webpack_public_path__ + "static/media/tooltipImg.aae9fb16.png";